"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../style/theme");

var _fa = require("react-icons/fa");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Icon = (0, _styledComponents.default)(function (_ref) {
  var p = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement(_fa.FaCaretDown, p);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 3px;\n  transform: translateX(-50%)\n    ", ";\n  transition: 0.2s;\n  font-size: 28px;\n  color: ", ";\n  cursor: pointer;\n  pointer-events: none;\n"])), function (p) {
  return p.$isNavVisible ? "rotate(180deg)" : "rotate(0deg)";
}, function (_ref2) {
  var $iconHover = _ref2.$iconHover;
  return (0, _theme.th)("colors.transparentWhite.".concat($iconHover ? "9" : "5"));
});

var Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 50%;\n  backface-visibility: hidden;\n  perspective: 1000;\n  transform: translateX(-50%) translateZ(0) translateY(50px);\n  transition: 0.2s;\n  display: ", ";\n"])), function (_ref3) {
  var isToggleable = _ref3.isToggleable;
  return isToggleable ? "block" : "none";
});

var Path = _styledComponents.default.path(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));

var HideButton = function HideButton(_ref4) {
  var onClick = _ref4.onClick,
      isNavVisible = _ref4.isNavVisible,
      isToggleable = _ref4.isToggleable;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      iconHover = _useState2[0],
      setIconHover = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(Container, {
    isToggleable: isToggleable
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "204",
    height: "31",
    viewBox: "0 0 264.707 40.297"
  }, /*#__PURE__*/_react.default.createElement(Path, {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M12485,1183.4l.051-13H12715v13s42.944-.092-9,0-52.406,27.3-106,27.3-51.1-27.358-106.051-27.3S12485,1183.4,12485,1183.4Z",
    transform: "translate(-12466.968 -1170.399)",
    fill: "#273c49",
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setIconHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIconHover(false);
    }
  })), /*#__PURE__*/_react.default.createElement(Icon, {
    $iconHover: iconHover,
    onClick: onClick,
    $isNavVisible: isNavVisible
  }));
};

HideButton.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  isToggleable: _propTypes.default.bool.isRequired,
  isNavVisible: _propTypes.default.bool
};
var _default = HideButton;
exports.default = _default;